import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Navigations from "../../config/navbar";
import Footer from "../../components/footer";
import Swal from "sweetalert2";
import emailjs from "emailjs-com";
import firebase from "../../config/firebase";
var db = firebase.database();
class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.sendEmail = this.sendEmail.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  }

  sendEmail(e) {
    e.preventDefault();
    const { from_name, user_email, user_budget, selected_product, message } =
      this.state;
    console.log({
      from_name,
      user_email,
      user_budget,
      selected_product,
      message,
    });

    if (selected_product === undefined || selected_product === "") {
      Swal.fire({
        title: "Alert!",
        text: "Please Fill All Fields",
        icon: "error",
        confirmButtonText: "OK",
      });
    } else {
      emailjs
        .sendForm(
          "gmail",
          "template_opwjw88",
          e.target,
          "user_9GNAql6wVXgFLUtYx6xjP"
        )
        .then(
          (result) => {
            console.log(result.text);
            var newPostKey = db.ref().child("Email_Data").push().key;
            var onj = {
              from_name,
              user_email,
              user_budget,
              selected_product,
              message,
              createAt: new Date().toLocaleString(),
              newPostKey,
            };
            db.ref("Email_Data/" + newPostKey)
              .set(onj)
              .then((e) => {
                this.setState({
                  success: "Successfully",
                  visible: true,
                  modal: false,
                  from_name: "",
                  user_email: "",
                  user_budget: "",
                  selected_product: "",
                  message: "",
                });
              })
              .catch((error) => {
                console.log("Error: ", error);
                this.setState({
                  errorMessage: error.message,
                  visiableError: true,
                });
              });
            Swal.fire({
              title: "Thank you for getting in touch!",
              text: "We appreciate you contacting us. One of our colleagues will get back in touch with you soon! Have a great day!",
              icon: "success",
              confirmButtonText: "OK",
            });
          },
          (error) => {
            console.log(error.text);
          }
        );
    }
  }

  render() {
    const { from_name, user_email, user_budget, selected_product, message } =
    this.state;
    return (
      <div>
        <Navigations />
        <div
          style={{
            borderBottom: "3px solid black",
            textAlign: "center",
            marginTop: "5rem",
          }}
        >
          <h1 style={{ color: "rgb(118, 102, 223)" }}>Get in Touch</h1>
          <h4 style={{ color: "rgb(118, 102, 223)" }}>
            Send a general message to related to Websites, Mobile Applications
            static Websites and Landing Pages etc...
          </h4>
        </div>
        <section class="py-5">
          <div class="container">
            <h2 class="mb-5 text-center">
              I’m excited to learn about your project. Ready to get started?
            </h2>
            <div class="row justify-content-center">
              <div class="col-md-9 ">
                <form
                  className="contact-form needs-validation"
                  novalidate
                  onSubmit={this.sendEmail}
                >
                  <div class="form-row">
                    <div class="col">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Full Name"
                        name="from_name"
                        value={from_name}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                    <div class="col">
                      <input
                        type="email"
                        class="form-control"
                        placeholder="Email"
                        name="user_email"
                        value={user_email}
                        onChange={this.handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div class="form-row mt-3">
                    <div class="col">
                      <div class="input-group mb-2">
                        <div class="input-group-prepend">
                          <div class="input-group-text">$</div>
                        </div>
                        <input
                          type="number"
                          class="form-control"
                          id="inlineFormInputGroup"
                          placeholder="Budget in Dollar"
                          name="user_budget"
                          value={user_budget}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <select
                        class="form-control mb-3"
                        name="selected_product"
                        value={selected_product}
                        onChange={this.handleChange}
                        required
                      >
                        <option disabled="" selected="">
                          Select product
                        </option>
                        <option>Web App</option>
                        <option>Mobile App</option>
                        <option>Both (Web & Mobile)</option>
                      </select>
                    </div>
                  </div>
                  <textarea
                    class="form-control mb-3"
                    id="textarea-contacts-01"
                    rows="5"
                    placeholder="Project Details..."
                    name="message"
                    value={message}
                    onChange={this.handleChange}
                    required
                  ></textarea>
                  <button
                    style={{
                      backgroundColor: "rgb(118, 102, 223)",
                      color: "white",
                    }}
                    class="btn btn-block"
                    type="submit"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

Contact.propTypes = {
  fluid: PropTypes.bool,
  // applies .container-fluid className
};

export default withRouter(Contact);
